import type { ExtendedProductMainOffer } from 'src/areas/product/components/product-context';
import type { PriceList, ProductMainOffer } from 'src/types';
import {
  filterOffersGeneric,
  filterShippingsGeneric,
} from './filtering-generic';
import type { IFilter } from './types';

export const getAllOffersAsArray = (
  priceList?: Pick<PriceList, 'nodes'> | null
): ProductMainOffer[] => {
  const offers = priceList?.nodes?.filter(x => x) as
    | ProductMainOffer[]
    | null
    | undefined;
  return offers ?? [];
};

export const filterOffers = (
  filters: IFilter[],
  priceList?: Pick<PriceList, 'nodes'> | null
): ExtendedProductMainOffer[] => {
  let filteredOffers = getAllOffersAsArray(priceList);
  filters.forEach(filter => {
    filteredOffers = filterOffersGeneric(filteredOffers, filter);
  });
  return filterShippingsGeneric(filteredOffers, filters);
};
